import React from 'react';
import { TagButton } from '../../../../ui';
import { CheckpointQueueAccessType } from '../../domain/models/CheckpointQueueAccessType';
import { useAccessTypeName } from './helpers/useAccessTypeName';

interface IAccessTypeFilterButtonProps {
	accessType: CheckpointQueueAccessType;
	onSelect: (accessType: CheckpointQueueAccessType) => void;
	active?: boolean;
	disabled?: boolean;
}

export const AccessTypeFilterButton = ({
	accessType,
	onSelect,
	active,
	disabled,
}: IAccessTypeFilterButtonProps) => {
	const onClick = () => onSelect(accessType);
	const name = useAccessTypeName(accessType);

	return (
		<TagButton
			active={active}
			onClick={onClick}
			disabled={disabled}
			aria-current={active}
		>
			{name}
		</TagButton>
	);
};
